// series/series

$(document).ready(function () {
    initSubscriptionSeries();
});

var lastClickedBtn = null;

function initSubscriptionSeries(parent) {
    var $unfollowModal = $('#unfollow-serie-modal');
    // click outside modal close
    $unfollowModal.click(function () {
        $unfollowModal.hide();
        lastClickedBtn = null;
    });
    // if click modal do not close
    $('#unfollow-serie-modal .modal-content').click(function(e) {
        e.stopPropagation();
    });
    // modal cancel button close
    $('#unfollow-serie-modal .btn-modal-cancel-unfollow').click(function() {
        $unfollowModal.hide();
        lastClickedBtn = null;
    });
    // modal unfollow button
    $('#unfollow-serie-modal .btn-modal-unfollow').click(function() {
        $unfollowModal.hide();
        unfollow(lastClickedBtn);
        lastClickedBtn = null;
    });
    // follow/unfollow button
    $("body").find('.btn-subscribe-serie').click(function () {
        if (global_tokyvideo_guest) {
            showLoginRegistrarModal();
        } else {
            lastClickedBtn = this;
            changeSubscriptionSerieFromList(this, $unfollowModal);
        }
        return false;
    });
}
